import { render, staticRenderFns } from "./RegNote.vue?vue&type=template&id=4f6f3588&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./RegNote.vue?vue&type=script&lang=js"
export * from "./RegNote.vue?vue&type=script&lang=js"
import style0 from "./RegNote.vue?vue&type=style&index=0&id=4f6f3588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f3588",
  null
  
)

export default component.exports